<template>
  <b-modal title="Conclusão do Laudo Técnico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-form-group label-cols="2" label="Recomendações:" label-align="center">
            <b-form-textarea v-model="template.recomendar" rows="8"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Recomendações</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.recomendacoes" :fields="fields.item_recomendacoes"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10">
          <b-form-group label="Recomendação:" label-for="recomendacao" label-cols="2" label-align="right">
            <b-form-input id="recomendacao" v-model="recomendacao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="add()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="del()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Conclusão do Laudo</b-alert>
      <b-col cols="12">
        <b-form-group label-cols="2" label="Conclusão:" label-align="center">
          <b-form-textarea v-model="template.conclusao" rows="8"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ModalDeLaudoTecnicoMotor",

  components: {},

  data() {
    return {
      show: false,
      template: new LaudoTecnico(),
      fields: new ReportFields(),
      recomendacao: "",
      files: new Array(),
    };
  },

  methods: {
    add() {
      this.template.recomendacoes.push({
        item: this.template.recomendacoes.length + 1,
        recomendacao: this.recomendacao,
      });
    },

    del() {
      if (this.template.recomendacoes.length > 0) {
        this.template.recomendacoes.pop();
      }
    },

    call(laudo) {
      this.show = !this.show;
      this.template = laudo;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
